import { render } from "./ShopView.vue?vue&type=template&id=65176ab9&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"

import "./ShopView.vue?vue&type=style&index=0&id=65176ab9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65176ab9"]])

export default __exports__